import axios, { AxiosResponse } from 'axios';

/**
 * Расчет налога на авто
 */
export const calculateVehicleTax = (data: any): Promise<AxiosResponse> => {
    return axios.post('/services/isnaportal/open-api/calculator/calculate-vehicle-tax', data);
};



